import React from "react";
import { Button } from "reactstrap";

type Props = Readonly<{
  disabled: boolean;
  onClick: () => void;
}>;

const CONFIRM_RESET_MESSAGE = "Are you sure you want to reset this job? All changes will be lost.";

export const ResetButton = ({ disabled, onClick }: Props) => {
  return (
    <Button
      color="danger"
      disabled={disabled}
      onClick={e => {
        e.preventDefault();
        if (!window.confirm(CONFIRM_RESET_MESSAGE)) {
          return;
        }
        onClick();
      }}
      type="reset"
    >
      Reset
    </Button>
  );
};
ResetButton.displayName = "ResetButton";
